import { TypedMatNode } from "../_Base";
import { BaseTextureMapController, BooleanParamOptions, NodePathOptions } from "./_BaseTextureController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { TangentSpaceNormalMap, ObjectSpaceNormalMap } from "three";
var NormalMapMode = /* @__PURE__ */ ((NormalMapMode2) => {
  NormalMapMode2["TANGENT"] = "tangent";
  NormalMapMode2["OBJECT"] = "object";
  return NormalMapMode2;
})(NormalMapMode || {});
const NORMAL_MAP_MODES = ["tangent" /* TANGENT */, "object" /* OBJECT */];
const NormalMapModeByName = {
  ["tangent" /* TANGENT */]: TangentSpaceNormalMap,
  ["object" /* OBJECT */]: ObjectSpaceNormalMap
};
export function NormalMapParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useNormalMap = ParamConfig.BOOLEAN(0, {
        separatorBefore: true,
        ...BooleanParamOptions(TextureNormalMapController)
      });
      this.normalMap = ParamConfig.NODE_PATH("", NodePathOptions(TextureNormalMapController, "useNormalMap"));
      this.normalMapType = ParamConfig.INTEGER(0, {
        visibleIf: { useNormalMap: 1 },
        menu: {
          entries: NORMAL_MAP_MODES.map((name, value) => {
            return { name, value };
          })
        }
      });
      this.normalScale = ParamConfig.VECTOR2([1, 1], { visibleIf: { useNormalMap: 1 } });
      this.normalScaleMult = ParamConfig.FLOAT(1, {
        range: [0, 1],
        rangeLocked: [false, false],
        visibleIf: { useNormalMap: 1 }
      });
    }
  };
}
class TextureNormalMapParamsConfig extends NormalMapParamConfig(NodeParamsConfig) {
}
class TextureNormalMapMatNode extends TypedMatNode {
}
export class TextureNormalMapController extends BaseTextureMapController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
    this.add_hooks(this.node.p.useNormalMap, this.node.p.normalMap);
  }
  async update() {
    const { p, pv, material } = this.node;
    this._update(this.node.material, "normalMap", p.useNormalMap, p.normalMap);
    const normalMapType = NormalMapModeByName[NORMAL_MAP_MODES[pv.normalMapType]];
    const mat = material;
    mat.normalMapType = normalMapType;
    mat.normalScale.copy(pv.normalScale).multiplyScalar(pv.normalScaleMult);
  }
  static async update(node) {
    node.controllers.normalMap.update();
  }
}
